import React, { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState, actions } from "../../state/reducer";
import { CloseIcon } from "../../icons/close";
import NotificationItem from "./item";

const NotificationBlock = () => {
  const State = useSelector((state: RootState) => state);
  const dispatch = useDispatch();

  const isActive = State.notifyOpen;
  const { notifications, hotNotify } = State;

  const close = () => {
    dispatch(actions.notifyOpen(false));
  };

  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
    const target = e.target as HTMLDivElement;
    if (target.classList.contains("modal-overlay")) {
      close();
    }
  };

  return (
    <>
      {isActive && (
        <div
          id="masterOverlay"
          className="modal-overlay"
          onClick={handleOverlayClick}
        />
      )}
      <div className={`notificationBlock${isActive ? " active" : ""}`}>
        <div className="notifyHeadingBlock">
          <h2>Уведомления</h2>
          <div className="closeNotifyIcon" onClick={close}>
            <CloseIcon width={18} height={18} />
          </div>
        </div>
        <div className="h100 columnLeft">
          {notifications.length === 0 && (
            <div className="emptyNotify w100 gridCenter">
              Пока нет новых уведомлений
            </div>
          )}
          {notifications.map((item, index) => {
            return <NotificationItem key={`ntfy${index}`} data={item} />;
          })}
        </div>
      </div>
      {hotNotify && (
        <div className="notifyModal">
          <NotificationItem data={hotNotify} />
        </div>
      )}
    </>
  );
};

export default NotificationBlock;
